/* eslint-disable @typescript-eslint/no-empty-function */
import React, { ReactNode } from 'react';

import { useCasTreeTransfer } from './hooks';
type ContextType = ReturnType<typeof useCasTreeTransfer>;
const TreeTransferContext = React.createContext<ContextType>({
  finallyValue: [],
  checkListLeft: [],
  checkListRight: [],
  dataSourceRight: { treeData: [] },
  dataSourceLeft: { treeData: [] },
  defaultValue: [],
  flatArray: [],
  sonParMap: new Map(),
  isBrightLeft: false,
  isBrightRight: false,
  indeterminateLeft: false,
  readOnlyAllKeyRight: [],
  readOnlyDataSourceRight: { treeData: [] },
  readOnlyAllKeyLeft: [],
  readOnlyTreeDataSource: { treeData: [] },
  disabled: false,
  isLeftOnly: false,
  handleFinallyValueChange: () => {},
  handleCheckListLeftChange: () => {},
  handleCheckListRightChange: () => {},
  handleDataSourceRightChange: () => {},
  handleDataSourceLeftChange: () => {},
  handleFlatArrayChange: () => {},
  handleSonParMapChange: () => {},
  handleReadOnlyAllKeyRightChange: () => {},
  handleReadOnlyDataSourceRightChange: () => {},
  handleIsBrightLeftChange: () => {},
  handleIsBrightRightChange: () => {},
  handleIndeterminateLeftChange: () => {},
  handleDefaultValueChange: () => {},
  handleReadOnlyAllKeyLeftChange: () => {},
  handleReadOnlyTreeDataSourceChange: () => {},
  handleDisabledChange: () => {},
  handleIsLeftOnlyChange: () => {},
});
export const CasTreeTransferProvider: React.FC<{ children: ReactNode }> = (
  props
) => {
  return (
    <TreeTransferContext.Provider value={useCasTreeTransfer()}>
      {props.children}
    </TreeTransferContext.Provider>
  );
};

// export const CasTreeTransferProvider = ({
//   children,
//   value,
// }: {
//   children: React.ReactNode;
//   value: ContextType;
// }) => {
//   return (
//     <TreeTransferContext.Provider value={value}>
//       {children}
//     </TreeTransferContext.Provider>
//   );
// };

export const useCasTreeTransferContext = () => {
  const context = React.useContext(TreeTransferContext);
  return context;
};
